"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsLayout = void 0;
const react_1 = __importStar(require("react"));
const helpers_1 = require("../../helpers");
const TabsLayout_styles_1 = require("./TabsLayout.styles");
const StackView_1 = require("../../StackView");
const View_1 = require("../../View");
exports.TabsLayout = (0, helpers_1.createUIElement)('TabsLayout', ({ tabs, body, ['data-selector-id']: initialDataSelectorId, style, className }, ref) => {
    const testId = (0, react_1.useMemo)(() => initialDataSelectorId || 'tabs-layout', [initialDataSelectorId]);
    return (react_1.default.createElement(TabsLayout_styles_1.StyledTabsLayout, { ref: ref, testId: testId, style: style, direction: StackView_1.STACK_DIRECTION.column, align: StackView_1.STACK_ALIGN.fill, spaceFill: View_1.SPACE_FILL.all, className: (0, helpers_1.cn)('vm-TabsLayout', className) },
        react_1.default.createElement(StackView_1.StackView, { spaceAll: View_1.INDENT.m, spaceBottom: View_1.INDENT.none }, tabs),
        body));
});
//# sourceMappingURL=TabsLayout.js.map